import React, { useState, useEffect } from "react";
import "./GiftPage.css";
import shenronImage from "../assets/shenron.jpg";

function GiftPage() {
    const [footerText, setFooterText] = useState("Happy Birthday Devesh!!");

    useEffect(() => {
        // Change text after 10 seconds (4s black fade + 6s additional delay)
        const timer = setTimeout(() => {
            setFooterText("Check washing machine for your gift!!");
        }, 10000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="gift-page">
            <div className="gift-container">
                <div className="gift-image-container">
                    <img src={shenronImage} alt="Shenron" className="gift-image" />
                </div>
                <footer className="gift-footer">
                    <h1 className="gift-message">{footerText}</h1>
                </footer>
            </div>
        </div>
    );
}

export default GiftPage;
